import { useEffect, useState } from "react";

import { Card } from "../../../components/Card";

import { MUITable } from "../../../components/Table/MUITable";
import { api } from "../../../services/api";
import { DeleteModal } from "../../../components/Feedback/DeleteModal";
import { AxiosError } from "axios";
import { EditButton } from "../../../components/molecules/TableListButton/EditButton";
import { ButtonListButton } from "../../../components/organisms/ButtonListBox";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../../../components/atoms/Button/AddButton";

interface Category {
  id: string;
  name: string;
}

export function ListCategories() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  useEffect(() => {
    api
      .get("categories")
      .then((response) => setCategories(response.data))
      .catch((err: AxiosError) => {});
  }, [navigate]);
  return (
    <>
      <Card
        border="#2b88a1"
        title="Categorias"
        header={<AddButton link="/categoria/cadastrar" />}
        body={
          <MUITable
            data={categories.map((category) => [category.id, category.name])}
            columns={[
              {
                name: "id",
                options: {
                  display: "excluded",
                  filter: false,
                  sort: false,
                },
              },
              {
                name: "Nome",
              },
              {
                name: "Ações",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRender: (dataIndex: any, rowIndex: any) => {
                    return (
                      <ButtonListButton>
                        <EditButton
                          link={`/categoria/editar/${rowIndex.rowData[0]}`}
                        />
                        <DeleteModal
                          onDelete={(id) => {
                            setCategories(
                              categories.filter(
                                (category) => category.id !== id
                              )
                            );
                          }}
                          id={rowIndex.rowData[0]}
                          route="categories/"
                          error_message="Não foi possível remover a categoria"
                          success_message="Categoria removida com sucesso"
                        />
                      </ButtonListButton>
                    );
                  },
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
